module.exports = __webpack_public_path__ + "static/media/featureSmart_illust.760592c9.gif";